import { subDays } from 'date-fns';

import { BettermentAccount } from '../../Shared/data';
import { Account, Customer } from '../data';

export function isOlderAccount(account: Account): boolean {
  return new Date(account.createdAt) < subDays(new Date(), 30);
}

export const intoBettermentAccount = (account: Account, customer: Customer): BettermentAccount => {
  return {
    graphqlId: '',
    name: account.name,
    type: 'betterment_checking',
    displayBalanceCents: account.accountBalanceCents,
    destinationAccountsIds: [],
    fullWithdrawalThresholdAmountCents: 0,
    fullWithdrawalThresholdPercentText: '',
    icon: account.icon,
    checkingAccount: {
      ...account,
      locked: customer.isLocked || account.isLocked,
      available: true,
    },
  };
};
